export const REQUEST_ROW_SIZE = 14;

export const VALIDATION_MESSAGE = "Invalid input request";
